<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <el-form-item label="公司" prop="companyId">
        <wList v-if="visible" v-model="dataForm.companyId"  type="1" :disabled="dataForm.id" dataUrl= "/sys/tscheduleaccountoperate/getCompanyList" placeholder="公司名称"></wList>
          <!-- <wList v-model="dataForm.companyId" :disabled="dataForm.id" dataUrl="/sys/companies/list" placeholder="请选择"></wList> -->
      </el-form-item>

      <el-form-item label="充值金额（元）" class="styW" prop="amount" >
          <el-input type="number" v-model="dataForm.amount" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="录入时间" prop="effectiveDate"> 
        <el-date-picker
                  v-model="dataForm.createDate"
                  disabled
                  type="datetime"
                  :default-value="new Date()"
                  placeholder=""
                  value-format="yyyy-MM-dd HH:mm:ss"> 
          </el-date-picker>
      </el-form-item>
     
      </el-form>
      <el-dialog
      width="30%"
      title="添加确认？"
      :visible.sync="innerVisible"
      append-to-body>
      <span>{{ innerVisibleText }}</span>
      <template slot="footer">
        <el-button @click="innerVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="dataFormSubmitHandle(1)">{{ $t('confirm') }}</el-button>
     </template>
    </el-dialog>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      wdisabled: false,
      innerVisible: false,
      innerVisibleText: '',
      dataForm: {
        id: '',
        companyId: '',
        amount: '',
        createDate: '',
      }
    }
  },
  computed: {
    dataRule () {
      return {
        company: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      
       
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
         
          this.getInfo()
        }else{
          this.getTime()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tscheduleaccountoperate/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log(res.data)
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        // this.getTime()
      }).catch(() => {})
    },
    getTime(){
      let now = new Date();
      let year = now.getFullYear(); // 获取四位数的年份，例如 2023
      let month = now.getMonth() + 1; // 获取当前月份，范围为 0-11，需要加上 1
      let date = now.getDate(); // 获取当前日期
      let hours = now.getHours(); // 获取当前小时数，范围为 0-23
      let minutes = now.getMinutes(); // 获取当前分钟数，范围为 0-59
      let seconds = now.getSeconds(); // 获取当前秒数，范围为 0-59
      month = month < 10 ? '0' + month : month
      date = date < 10 ? '0' + date : date
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds
      // // console.log(year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds);
      this.dataForm.createDate = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
      // return  year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function (logo='') {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.logo = logo
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tscheduleaccountoperate/', this.dataForm).then(({ data: res }) => {
          console.log(res) 

       
         if(res.code == 10033){
           this.innerVisibleText = res.msg
           this.innerVisible = true
           return
         }
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
         
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.innerVisible = false
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style scoped>
  .styW{
    width: 325px;
  }
</style>